import { normalizeMobile } from './mobile';

/**
 * The phone's contact picker (Android Chrome). iPhone browsers don't have it, so callers show
 * their "Pick from contacts" button only when this is true and fall back to typing a number.
 */
export const contactsSupported = typeof navigator !== 'undefined'
    && 'contacts' in navigator && typeof window !== 'undefined' && 'ContactsManager' in window;

/** One picked contact → { name, mobile }, the number cleaned the same way as a typed one. */
export const parseContactEntry = (c) => {
    const name = (c.name && c.name[0]) || '';
    const mobile = c.tel && c.tel.length > 0 ? normalizeMobile(c.tel[0]) : '';
    return { name, mobile };
};

/** Open the picker for one contact; resolves to { name, mobile } or null if cancelled. */
export const pickOneContact = async () => {
    const picked = await navigator.contacts.select(['name', 'tel'], { multiple: false });
    return picked && picked.length ? parseContactEntry(picked[0]) : null;
};
